module.exports = __webpack_public_path__ + "img/64-l.359b546f.png";